export const SET_USER_DATA = "SET_USER_DATA";
export const GET_USER_DATA = "GET_USER_DATA";
export const SET_LOGO = "SET_LOGO";
export const SET_USAGE = "SET_USAGE";
export const SET_ORGANIZATION = "SET_ORGANIZATION";
export const SET_TOLLFREE_NUMBER = "SET_TOLLFREE_NUMBER";
export const SET_TOLLFREE_NUMBER_STATUS = "SET_TOLLFREE_NUMBER_STATUS";
export const SET_TOLLFREE_NUMBER_PURCHASED = "SET_TOLLFREE_NUMBER_PURCHASED";
export const SET_CARD_EXPIRED = " SET_CARD_EXPIRED";
